<template>

<div class="article_bg">
<div class="container">
<div class="row">
<div class="article_style">
<h1 class="art_txt">  Checkout Our Latest <br> News & Articles </h1>
</div>
</div>

<div class="card_style"> 
<div class="row">  
<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
<div class="card">                        
      <div class="card_img"> <img src="/assets/Image-1.png"> </div>
      <div class="card-body">
        <h4 class="card-title"> Language Learning </h4>
        <hr>
        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
      </div>
      <div class="">
          <div class="container">
              <div class="row pill_Style">                               
              <div class="col-lg-7">
                  <div class="row">
                  <div class="profile">                                    
                  </div>                       
                  <h6 class="profile_text"> <i class="fa fa-eye"> 123 </i> &nbsp; &nbsp; &nbsp; &nbsp; <i class="fa fa-comment"> 124 </i> </h6>
                  </div>  
              </div>
              <div class="col-lg-5">
                  <div class="pill"> Read More </div>
              </div>
              </div>
              </div>
      </div>
      
</div>
</div>

<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div class="card">                        
                      <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                      <div class="card-body">
                        <h4 class="card-title"> Language Learning </h4>
                        <hr>
                        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                      </div>
                      <div class="">
                          <div class="container">
                              <div class="row pill_Style">                               
                              <div class="col-lg-7">
                                  <div class="row">
                                  <div class="profile">                                    
                                  </div>                       
                                  <h6 class="profile_text"> <i class="fa fa-eye"> 12 </i>  &nbsp; &nbsp; &nbsp; &nbsp; <i class="fa fa-comment"> 12 </i> </h6>
                                  </div>  
                              </div>
                              <div class="col-lg-5">
                                  <div class="pill"> Read More </div>
                              </div>
                              </div>
                              </div>
                      </div>
                      
                  </div>
</div>

<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div class="card">                        
                      <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                      <div class="card-body">
                        <h4 class="card-title"> Language Learning </h4>
                        <hr>
                        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                      </div>
                      <div class="">
                          <div class="container">
                              <div class="row pill_Style">                               
                              <div class="col-lg-7">
                                  <div class="row">
                                  <div class="profile">                                    
                                  </div>                       
                                  <h6 class="profile_text"><i class="fa fa-eye"> 12 </i>   &nbsp; &nbsp; &nbsp; &nbsp;  <i class="fa fa-comment"> 12 </i> </h6>
                                  </div>  
                              </div>
                              <div class="col-lg-5">
                                  <div class="pill"> Read More </div>
                              </div>
                              </div>
                              </div>
                      </div>
                      
                  </div>
</div>

<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div class="card">                        
                      <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                      <div class="card-body">
                        <h4 class="card-title"> Language Learning </h4>
                        <hr>
                        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                      </div>
                      <div class="">
                          <div class="container">
                              <div class="row pill_Style">                               
                              <div class="col-lg-7">
                                  <div class="row">
                                  <div class="profile">                                    
                                  </div>                       
                                  <h6 class="profile_text"><i class="fa fa-eye"> 12 </i>   &nbsp; &nbsp; &nbsp; &nbsp;  <i class="fa fa-comment"> 12 </i> </h6>
                                  </div>  
                              </div>
                              <div class="col-lg-5">
                                  <div class="pill"> Read More </div>
                              </div>
                              </div>
                              </div>
                      </div>
                      
                  </div>
</div>

</div>
</div>
</div>
</div>


<section :style="{'background-image':'url(assets/Gradient.png)'}" class="py-5">
    <div class="container">
    <!-- FOR DEMO PURPOSE -->
     
      <div class="row">


            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mx-auto">
              <!-- CUSTOM BLOCKQUOTE -->
              <blockquote class="blockquote blockquote-custom bg-white p-2 shadow rounded">
                  <div class="blockquote-custom-icon bg-info shadow-sm">
                    <i class="bi bi-file-earmark-text text-white" style="padding-bottom: 6px"></i>
                    </div>
                  <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                  <p class="mb-0 mt-2 font-italic" style="text-align: center;">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo <a href="#" class="text-info">@consequat</a>."</p>
                  <footer class="blockquote-footer pt-4 mt-4 border-top">Someone famous in
                      <cite title="Source Title">Source Title</cite>
                  </footer>
              </blockquote><!-- END -->

            </div>
       
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mx-auto ">

                <!-- CUSTOM BLOCKQUOTE -->
                <blockquote class="blockquote blockquote-custom bg-white p-2 shadow rounded">
                    <div class="blockquote-custom-icon bg-info shadow-sm"><i class="bi bi-file-earmark-text text-white" style="padding-bottom: 6px"></i></div>
                    <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                    <p class="mb-0 mt-2 font-italic" style="text-align: center;">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo <a href="#" class="text-info">@consequat</a>."</p>
                    <footer class="blockquote-footer pt-4 mt-4 border-top">Someone famous in
                        <cite title="Source Title">Source Title</cite>
                    </footer>
                </blockquote><!-- END -->

            </div>
            
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mx-auto">
                <!-- CUSTOM BLOCKQUOTE -->
                <blockquote class="blockquote blockquote-custom bg-white p-5 shadow rounded">
                    <div class="blockquote-custom-icon bg-info shadow-sm"><i class="bi bi-file-earmark-text text-white" style="padding-bottom: 6px"></i></div>
                    <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                    <p class="mb-0 mt-2 font-italic" style="text-align: -webkit-left;">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo <a href="#" class="text-info">@consequat</a>."</p>
                    <footer class="blockquote-footer pt-4 mt-4 border-top">Someone famous in
                        <cite title="Source Title">Source Title</cite>
                          
                    </footer>
                </blockquote><!-- END -->
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mx-auto">
                <!-- CUSTOM BLOCKQUOTE -->
                <blockquote class="blockquote blockquote-custom bg-white p-5 shadow rounded">
                  <div class="card_img"> <img src="/assets/Image-1.png"> </div>
                  <div class="blockquote-custom-icon bg-info shadow-sm"><i class="bi bi-file-earmark-text text-white" style="padding-bottom: 6px"></i></div>
                  <p class="mb-0 mt-2 font-italic" style="text-align: -webkit-left;">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo <a href="#" class="text-info">@consequat</a>."</p>
                  <footer class="blockquote-footer pt-4 mt-4 border-top">Someone famous in
                      <cite title="Source Title">Source Title</cite>
                  </footer>
                </blockquote><!-- END -->
            </div>


      </div>


</div>
</section>

</template>

<script>
export default
{
    name: 'Article',
};

</script>

<style scoped>

.article:hover{
box-shadow: 0px 4px 15px -1px rgb(182, 182, 182);
border: 0;  

}



.icon_box
{

max-width: 50%;

}

.blockquote-custom {
  position: relative;
  font-size: 1.1rem;
  
}

.bg-info {
    background-color:#378475 !important;
}

i .bi bi-file-earmark-text
{

padding-bottom: 6px;

}

.bg-info:hover{
  
    -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}

.text-info {
    color: #ff1616 !important;
}

.blockquote-custom-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -25px;  
  left: 50px;
  background-color:#378475;
  border: 3px solid white;
}



.article_bg
{

background-color: whitesmoke; 
padding-bottom: 40px;

}

html {
  box-sizing: border-box;
  font-size: 62.5%;
}

.bg-info:hover{
  
    -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}


a {
  text-decoration: none;
}

.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.section_title {
  margin-top: 3rem;
  margin-bottom: 4rem;
}

img {
  width: 100%;
  height: auto;
  margin: 0;
}

.articles {
  width: 100%;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  flex-wrap: wrap;
  margin-bottom: 5rem;
}

.article {
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 1;
  padding: 2rem;
  background-color: white;
  margin-top: 3rem;
  &:hover {
    img {
      transform: scale(1.05);
    }

    .read_more {
      opacity: 1;
      z-index: 1;
    }

    .author {
      opacity: 0;
      z-index: -1;
    }
  }

  a {
    color: #333;
  }

  .preview {
    position: relative;
    margin-bottom: 1.3rem;
    overflow: hidden;
    margin-top: -4rem;
    width: 100%;
    padding-bottom: 50%;
    .stretch {
      position: absolute;
    }
    img {
      vertical-align: middle;
      transition: all 0.25s ease-in-out;
    }
  }

  .cat {
    margin-bottom: 1rem;
    padding: 0.4rem 0.5rem;
    align-self: flex-start;
    a {
      color: #fff;
    }
    transition: all 0.3s;
  }

  .photography {
    background-color: rgba($color: #2b9eb3, $alpha: 0.8);
    &:hover {
      background-color: rgba($color: #2b9eb3, $alpha: 1);
    }
  }

  .art {
    background-color: rgba($color: #f71735, $alpha: 0.8);
    &:hover {
      background-color: rgba($color: #f71735, $alpha: 1);
    }
  }

  .cat,
  .article_footer {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 1.2rem;
    text-transform: uppercase;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  .description {
    margin-bottom: 2.5rem;
    font-size: 1.7rem;
  }

  .article_footer {
    border-top: 1px solid #e2e2e2;
    margin-top: auto;
    padding-top: 2rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    overflow: hidden;
  }

  .author,
  .read_more {
    display: block;
    grid-column: 1;
    grid-row: 1;
    transition: all 0.3s ease-out;
  }

  .read_more {
    opacity: 0;
    z-index: -1;
    a {
      display: block;
    }
    &:hover {
      a {
        color: #2b9eb3;
      }
    }
  }

  .author {
    z-index: 1;
  }
}

.stretch
{
  padding-bottom: 25px;  
}


.article_style
{
padding-top: 50px;
}


.card_style{
    padding-top: 0px;
    padding-bottom: 5px;
    margin-bottom: 32px;
    padding: 10px;
    margin: 0px;
}


img, svg {
    vertical-align: middle;
    max-width: 100%;
}



@media (min-width:1200px) and (max-width: 2000px) 
{


}

@media (min-width:992px) and (max-width: 1199px) 
{

.card_style .pill_Style
{
    white-space: nowrap;
}


}

@media (min-width:768px) and (max-width: 991px) 
{

.card_style .pill_Style
{
    white-space: nowrap !important;
}



}


@media (min-width:576px) and (max-width: 767px) 
{

.card_style .pill_Style
{
    white-space: nowrap !important;
}

.col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
    margin-bottom: 15px;
}



}


@media (min-width:320px) and (max-width: 575px) 
{



  
}


</style>